import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Centralized application version - update this single constant for version changes
export const APP_VERSION = 'V1.0213.19';
